import { Component } from '@angular/core';

@Component({
  selector: 'app-cards3-examples-20',
  templateUrl: './cards3-examples-20.component.html'
})
export class Cards3Examples20Component {}
